import { ECardType } from "@types";
import {
  schemaAllergies,
  schemaAppointment,
  schemaConditions,
  schemaFile,
  schemaHospitalizations,
  schemaIdCard,
  schemaMedications,
  schemaNotes,
  schemaPractitioners,
  schemaProcedures,
  schemaQuestions,
  schemaTestResults,
  schemaToDos,
  schemaVaccinations,
} from "Schema";
import { ZodType } from "zod";

const schemaCardType: { [key: ECardType | string]: ZodType } = {
  [ECardType.Files]: schemaFile,
  [ECardType.Allergies]: schemaAllergies,
  [ECardType.IdCard]: schemaIdCard,
  [ECardType.Procedures]: schemaProcedures,
  [ECardType.Hospitalizations]: schemaHospitalizations,
  [ECardType.Notes]: schemaNotes,
  [ECardType.Questions]: schemaQuestions,
  [ECardType.Vaccinations]: schemaVaccinations,
  [ECardType.Conditions]: schemaConditions,
  [ECardType.Medications]: schemaMedications,
  [ECardType.Practitioners]: schemaPractitioners,
  [ECardType.ToDos]: schemaToDos,
  [ECardType.Appointments]: schemaAppointment,
  [ECardType.TestResults]: schemaTestResults
};

export function getSchemaDetail(key?: ECardType | string): ZodType {
  return schemaCardType[key || ''] || schemaFile;
}
